// extracted by mini-css-extract-plugin
module.exports = {"info__version":"Info_info__version__1kyPT","info__version_text":"Info_info__version_text__3sZ4p"};